import React, { lazy } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';

export const CustomRoute = ({ component: Component, reduxStore: reduxStore, ...rest }) => (
  <Route {...rest} render={(props) => (
    <Component {...props} />
  )} />
);

